<template>
	<!-- <div class="two wide column"> 
	:class="$style.sombreado"-->
	<div :id="clave" :class="$style.tarjeta">
		<!-- <i class="certificate icon" style="color:#bc955c"></i> -->

		<div
			v-show="clave !== ''"
			:class="{
				[$style.sombreado]: esPrerequisito || esCorequisito
			}"
			class="ui raised card"
		>
			<img
				v-show="especialidad === true"
				src="@assets/images/especialidad.svg"
				style="color: rgb(188, 149, 92);
						width: 15px;
						right: 4px;
						top: 4px;
						position: absolute;"
			/>
			<div :class="$style.contenido">
				<div :class="$style.nombre" class="boldFont">{{ nombre }}</div>
				<div :class="$style.clave">{{ clave }}</div>
				<div :class="$style.creditos" class="boldFont">Créditos: {{ creditos }}</div>
			</div>
			<div :class="$style.extra" class="extra content">
				<a
					:class="$style.prerequisito"
					@mouseenter="hoverPrerequisitos(prerequisito)"
					@mouseleave="leavePrerequisitos(prerequisito)"
				>PRE</a>
				<a
					:class="$style.corequisito"
					@mouseenter="hoverCorequisitos(corequisito)"
					@mouseleave="leaveCorequisitos(corequisito)"
				>CO</a>
			</div>
		</div>
	</div>
</template>
<script>

export default {
	inheritAttrs: true,
	props: {
		clave: {
			type: String,
			default: () => ''
		},
		nombre: {
			type: String,
			default: () => ''
		},
		prerequisito: {
			type: Array,
			default: () => []
		},
		corequisito: {
			type: Array,
			default: () => []
		},
		ubicacion: {
			type: Number,
			default: 13
		},
		creditos: {
			type: Number,
			default: 13
		},
		esPrerequisito: {
			type: Boolean,
			default: false
		},
		esCorequisito: {
			type: Boolean,
			default: false
		},
		especialidad: {
			type: Boolean,
			default: false
		}
	},
	data: function() {
		return {
			// mostrar: false
		};
	},
	computed: {},
	watch: {},
	methods: {
		hoverPrerequisitos: function(prerequisito) {
			this.$emit('prerequisitos', [prerequisito]);
		},
		leavePrerequisitos: function(prerequisito) {
			this.$emit('borraPrerequisito', [prerequisito]);
		},
		hoverCorequisitos: function(corequisito) {
			// console.log("###################")
			// console.log(this.esCorequisito)
			// console.log("###################")
			// console.log(corequisito)
			this.$emit('corequisitos', [corequisito]);
		},
		leaveCorequisitos: function(corequisito) {
			this.$emit('borraCorequisito', [corequisito]);
		}
	}
};
</script>
<style lang="scss" module>
@import '@design';

.tarjeta {
	//  position: absolute;
	top: 50%;
	width: 9%;
	padding-right: 0 !important;
	padding-left: 0 !important;
	margin-right: 1em !important;
	margin-bottom: 30px;
	margin-left: 1em !important;
}

.sombreado {
	outline: solid 1px rgba(27, 57, 106, 0.9) !important;
	box-shadow: 0 3px 6px 0 rgba(27, 57, 106, 0.9) !important;
}

.nombre {
	width: 100%;
	height: 40px;
	font-size: 1em;
	font-style: normal;
	font-weight: bold;
	font-stretch: normal;
	line-height: 1.4;
	color: var(--dark-slate-blue-two);
	text-align: center;
	letter-spacing: normal;
	margin-top: 7px;
	overflow: hidden;
    text-overflow: ellipsis;
}

.clave {
	width: 100%;
	height: 25%;
	font-size: 1em;
	font-style: normal;
	font-weight: normal;
	font-stretch: normal;
	line-height: 1.4;
	color: #5c5d5d;
	text-align: center;
	letter-spacing: normal;
}

.creditos {
	width: 100%;
	height: 25%;
	font-size: 1em;
	font-style: normal;
	font-weight: bold;
	font-stretch: normal;
	line-height: 1.4;
	color: #5c5d5d;
	text-align: center;
	letter-spacing: normal;
}

.prerequisito {
	width: 25px;
	height: 14px;
	font-size: 1em;
	font-style: normal;
	font-weight: bold;
	font-stretch: normal;
	line-height: 1.4;
	color: #5c5d5d;
	text-align: center;
	text-decoration: none;
	letter-spacing: normal;
	position:absolute;
}

.corequisito {
	float: right;
	width: 25px;
	height: 14px;
	font-size: 1em;
	font-style: normal;
	font-weight: bold;
	font-stretch: normal;
	line-height: 1.4;
	color: #5c5d5d;
	text-align: center;
	letter-spacing: normal;
	
}

.prerequisito:hover {
	color: #161616 !important;
}
.corequisito:hover {
	color: #161616 !important;
}
.starsix {
	width: 0;
	height: 0;
	border-left: 5px solid transparent;
	border-right: 5px solid transparent;
	border-bottom: 10px solid red;
	position: relative;
}
.starsix:after {
	width: 0;
	height: 0;
	border-left: 5px solid transparent;
	border-right: 5px solid transparent;
	border-top: 10px solid red;
	position: absolute;
	content: '';
	top: 3px;
	left: -5px;
}

.contenido{
		padding:1em !important;
	}

@media (max-width: 1500px) {
  .tarjeta {
		top: 50%;
		width: 11%;
		padding-right: 0 !important;
		padding-left: 0 !important;
		margin-right: 5px !important;
		margin-bottom: 10px;
		margin-left: 5px !important;
	}
	.nombre {
		width: 100%;
		height: 23px;
		font-size: 0.6em;
		line-height: 1.4;
		color: var(--dark-slate-blue-two);
		text-align: center;
		letter-spacing: normal;
		margin-top: 14px;
	}
	.clave {
		font-size: 0.7em;
		
	}
	.creditos {
		font-size: 0.7em;
		height: 10px;
	}
	.prerequisito {
		font-size: 0.6em;
		height: 10px;
		
	}
	.corequisito {
		font-size: 0.6em;
		
	}
	.contenido{
		padding:0.3em !important;
	}
	.extra{
		padding: 0.3em 0.3em !important;
	}
}
</style>
